import { ExternalLink } from '../types';

export const links: ExternalLink[] = [
  {
    type: 'discord',
    url: 'https://discord.com/invite/NZkdjYwg9f',
    label: 'Join Discord Community',
    icon: 'discord',
  },
  {
    type: 'email',
    url: 'mailto:hey-you@feral-aud.io',
    label: 'hey-you@feral-aud.io',
    icon: 'email',
  },
  {
    type: 'appStore',
    url: 'https://apps.apple.com/us/developer/steffen-m%C3%B8lgaard-larsen/id1860980002',
    label: 'App Store',
    icon: 'apple',
  },
];

export const discordLink = links.find((link) => link.type === 'discord');
export const emailLink = links.find((link) => link.type === 'email');
export const appStoreLink = links.find((link) => link.type === 'appStore');
